import type { TimeZone } from '@iheartjane/types';
import { timezone as parseApiTimezones } from '@iheartjane/utils';
/* eslint-disable-next-line no-restricted-imports */
import dayjs from 'dayjs';
/* eslint-disable-next-line no-restricted-imports */
import type { Dayjs, OptionType } from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import calendar from 'dayjs/plugin/calendar';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import type { Time } from '@jane/shared/types';

dayjs.extend(advancedFormat);
dayjs.extend(calendar);
dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(customParseFormat);

interface FormatTimeParams {
  inputFormat?: OptionType;
  outputFormat?: string;
  time: Dayjs | Time;
  timezone?: TimeZone;
}

export function formatTime({
  time,
  outputFormat,
  inputFormat,
  timezone,
}: FormatTimeParams): string {
  if (timezone) {
    return dayjs(time, inputFormat)
      .tz(parseApiTimezones(timezone))
      .format(outputFormat);
  }
  return dayjs(time, inputFormat).format(outputFormat);
}

export function formatUtcTime(
  time: Dayjs | Time,
  outputFormat?: string,
  inputFormat?: string
): string {
  return dayjs.utc(time, inputFormat).format(outputFormat);
}

export function formatWithCalendar(
  time: Dayjs | Time,
  timezone: TimeZone,
  calendarFormats?: object,
  inputFormat?: OptionType
): string {
  let dayjsTime;
  if (timezone) {
    dayjsTime = dayjs(time, inputFormat).tz(parseApiTimezones(timezone));
  } else {
    dayjsTime = dayjs(time, inputFormat);
  }
  return dayjsTime.calendar(dayjs(), calendarFormats);
}
